import React from 'react';

export default props => (
    <svg viewBox="0 0 38 38" {...props}>
        <path fill="#FFF"
              d="M12.556 21.978c.455-.119.804-.475.92-.93l.585-2.31a1.28 1.28 0 0 1 1.087-.963c.914-.112 2.415-.264 3.854-.264 1.438 0 2.94.152 3.853.264a1.28 1.28 0 0 1 1.087.964l.585 2.309c.115.456.47.813.925.932l5.749 1.503a1.294 1.294 0 0 0 1.436-.584c.29-.477.561-1.203.56-2.249 0-3.272-1.89-6.901-14.197-6.901-12.306 0-14.197 3.627-14.197 6.901 0 1.048.272 1.774.563 2.253.299.49.875.726 1.43.581l5.76-1.506z"/>
    </svg>
);